<div *ngIf="pedidosLiberacao; else semPL ">
    <div class="card">
        <div class="row">
            <div class="col-sm-2 col-12 text-center">
                <h6 class="mb-0">Número do Pedido</h6>
            </div>
            <div class="col-sm-2 col-12 text-center">
                <h6 class="mb-0">Data de Liberação</h6>
            </div>
            <div class="col-sm-6 col-12 text-center">
                <h6 class="mb-0">Situação</h6>
            </div>
            <div class="col-sm-2 col-12 text-center">
                <h6 class="mb-0">Valor Liberado</h6>
            </div>
        </div>
    </div>
    <div class="card shadow" *ngFor="let pedido of pedidosLiberacao">
        <div class="card-header" (click)="expandirPL('PL'+pedido.id)">
            <div class="row">
                <div class="col-sm-2 col-12 text-center">
                    <h5 class="mb-0">Pedido N. {{pedido.numero}}</h5>
                </div>
                <div class="col-sm-2 col-12 text-center">
                    <h5 class="mb-0">{{pedido?.dataLiberacao | date: 'dd/MM/yyyy'}}</h5>
                </div>
                <div class="col-sm-6 col-12 text-center">
                    <h5 class="mb-0">{{pedido?.descricaoSituacaoDocumento}} - {{pedido?.descricaoFase}}</h5>
                </div>
                <div class="col-sm-2 col-12 text-center">
                    <h5 class="mb-0">R$ {{(pedido?.valorLiberado | bnMask: 'MOEDA')|| '-' }}</h5>
                </div>
            </div>
        </div>
        <div id="PL{{pedido.id}}" class="collapse">
            <div class="card-body">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Informações sobre o PL</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row" *ngIf="pedido.alertas">
                            <div class="col-sm-12 col-12">
                                <div class="alert alert-warning" role="alert" *ngFor="let alerta of pedido.alertas">
                                    <div [innerHTML]="alerta.mensagem"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2 col-12 ">
                                <h6 class="mb-0">N. Pedido Liberação</h6>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <p>{{pedido.numero}}</p>
                            </div>
    
                            <div class="col-sm-2  col-12 ">
                                <h6 class="mb-0">Data Contratação:</h6>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <p>{{(pedido.dataContratacao | date: 'dd/MM/yyyy') || '-'}}</p>
                            </div>
    
                            <div class="col-sm-2 col-12 ">
                                <h6 class="mb-0">Número Ref. BACEN:</h6>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <p>{{pedido?.numeroRefBacen || '-' }}</p>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <h6 class="mb-0">Data Protocolo:</h6>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <p>{{(pedido?.dataProtocolo | date: 'dd/MM/yyyy') || '-' }}</p>
                            </div>
                            <div class="col-sm-2 col-12 ">
                                <h6 class="mb-0">Situação:</h6>
                            </div>
                            <div class="col-sm-4 col-12 ">
                                <p>{{pedido?.descricaoSituacaoDocumento}} - {{pedido?.descricaoFase}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Valor Liberado:</h6>
                            </div>
                            <div class="col-sm-2 col-12 ps-10 pe-5">
                                <p>R$ {{(pedido?.valorLiberado | bnMask: 'MOEDA')|| '-' }}</p>
                            </div>
                            <div class="col-sm-2 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Valor Solicitado:</h6>
                            </div>
                            <div class="col-sm-2 col-12 ps-10 pe-5">
                                <p>R$ {{(pedido?.valorSolicitado | bnMask: 'MOEDA')|| '-' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Detalhamento do PL</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" *ngIf="pedido.parcelas; else semDetalhamento">
                        <div class="card" *ngFor="let parcela of pedido.parcelas" >
                            <div class="card-header" style="height: 70px;">
                                <div class="col-sm-3 col-12">
                                    <h6 class="mb-0">Fabricante</h6>
                                </div>
                                <div class="col-sm-12 col-12" >
                                    <h5>{{parcela.cnpj}} - {{parcela.nome}}</h5>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="card" *ngFor="let item of parcela.items">
                                    <div class="card-header">
                                        <div class="col-sm-2 col-12 ps-10 pe-5">
                                            <h6 class="mb-0">Item RDME: {{item.numeroItemRdme}}</h6>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row ms-2 mt-2">
                                            <div class="col-sm-2 col-12">
                                                <h6 class="mb-0">Qntd:</h6>
                                            </div>
                                            <div class="col-sm-1 col-12">
                                                <p>{{item.qntdEquipamentos}}</p>
                                            </div>
                                        </div>
                                        <div class="row ms-2">
                                            <div class="col-sm-2 col-1">
                                                <h6 class="mb-0">Equipamento:</h6>
                                            </div>
                                            <div class="col-sm-6 col-12">
                                                <p>{{item.codProdCfi}} - {{item.descricaoProduto}}</p>
                                            </div>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Parcela</th>
                                                        <th scope="col">Data Prevista</th>
                                                        <th scope="col">Valor Previsto</th>
                                                        <th scope="col">Evento</th>
                                                        <th scope="col">Detalhe</th>
                                                        <th scope="col">Valor Solicitado</th>
                                                        <th scope="col">Valor Liberado</th>
                                                        <th scope="col">Valor Glosado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let p of item.parcelas; let i = index">
                                                        <td>{{p.numeroParcela}}</td>
                                                        <td>{{p.dataPrevisaoLiberacao | date: 'dd/MM/yyyy'}}</td>
                                                        <td>R$ {{p.valorPrevistoLiberacao | bnMask: 'MOEDA'}}</td>
                                                        <td>{{p.evento}}</td>
                                                        <td>{{p.detalhe}}</td>
                                                        <td>R$ {{p.valorSolicitado | bnMask: 'MOEDA'}}</td>
                                                        <td>R$ {{p.valorLiberado | bnMask: 'MOEDA'}}</td>
                                                        <td>R$ {{p?.valorGlosado | bnMask: 'MOEDA' }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                        </div>
    
    
                    </div>
                </div>
                <div class="card" *ngIf="pedido.notasFiscais.length > 0">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Informações Sobre as Notas Fiscais</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card bg-light ps-3 pe-3 pt-3" *ngFor="let nota of pedido.notasFiscais">
                            <div class="row">
                                <div class="col-sm-1  col-12">
                                    <h6 class="mb-0">Número:</h6>
                                </div>
                                <div class="col-sm-1 col-12">
                                    <p>{{nota.numeroNota}}</p>
                                </div>
                                <div class="col-sm-1 col-12">
                                    <h6 class="mb-0">Valor:</h6>
                                </div>
                                <div class="col-sm-2 col-12">
                                    <p>R$ {{nota.valorNotaFiscal | bnMask: 'MOEDA'}}</p>
                                </div>
                                <div class="col-sm-2 col-12">
                                    <h6 class="mb-0">Data Emissão:</h6>
                                </div>
                                <div class="col-sm-2 col-12">
                                    <p>{{nota.dataEmissao | date: 'dd/MM/yyyy'}}</p>
                                </div>
                                <div class="col-sm-1 col-12">
                                    <h6 class="mb-0">Data Saída:</h6>
                                </div>
                                <div class="col-sm-2 col-12">
                                    <p>{{nota.dataSaida | date: 'dd/MM/yyyy'}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-2  col-12">
                                    <h6 class="mb-0">Cód Fiscal:</h6>
                                </div>
                                <div class="col-sm-2 col-12">
                                    <p>{{nota.codFiscal}}</p>
                                </div>
                                <div class="col-sm-2  col-12">
                                    <h6 class="mb-0">Descrição:</h6>
                                </div>
                                <div class="col-sm-3 col-12">
                                    <p>{{nota.descricao}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-12 ms-10 ">
                                    <h6 class="mb-0">Chave de Acesso da Nota Fiscal:</h6>
                                </div>
                                <div class="col-sm-12 col-12 ms-10 ">
                                    <p>{{nota.chaveNota || "-"}}</p>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">RDME</th>
                                            <th scope="col">Qtd</th>
                                            <th scope="col">Código Regime Tributário</th>
                                            <th scope="col">Código Fiscal de Operação</th>
                                            <th scope="col">CST</th>
                                            <th scope="col">CSOSN</th>
                                            <th scope="col">Valor Unitário</th>
                                            <th scope="col">Valor Total</th>
                                            <th scope="col">Identificação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of nota.itensNota">
                                            <td>{{item.numeroItemRdme}}</td>
                                            <td>{{item.qntItem}}</td>
                                            <td>{{item.codRegTributario || "-"}}</td>
                                            <td>{{item.codFiscOperacional || "-"}}</td>
                                            <td>{{item.codSistTributaria || "-"}}</td>
                                            <td>{{item.codSitOpeSimpNac}}</td>
                                            <td>R$ {{item.valorItem / item.qntItem | bnMask: 'MOEDA'}}</td>
                                            <td>R$ {{item.valorItem | bnMask: 'MOEDA'}}</td>
                                            <td>{{item.descricaoItem}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="pedido.observacoesProtocolo">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12">
                                <h6>Observações do PL</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card" *ngFor="let aviso of pedido.observacoesProtocolo">
                            <p>{{aviso.mensagem}}</p>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="pedido.motivosDevolucao">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12">
                                <h6>Motivos de Devolução</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card" *ngFor="let motivo of pedido.motivosDevolucao">
                            <p>{{motivo.mensagem}}</p>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="pedido.historicos">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-sm-8 col-12 ps-10 pe-5">
                                <h6 class="mb-0">Informações sobre o Histórico do PL</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="card ps-3 pt-3 pe-3">
                            <div class="table-responsive">
                                <table class="table table-hover table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">Data</th>
                                            <th scope="col">Evento</th>
                                            <th scope="col">Responsável</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let h of pedido.historicos">
                                            <td>{{h.dataEvento | date: 'dd/MM/yyyy'}}</td>
                                            <td>{{h.evento}}</td>
                                            <td>{{h.responsavel}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #semPL>
    <div >
        <h5>A PAC informada não possui pedidos de liberação</h5>
    </div>
</ng-template>
<ng-template #semDetalhamento>
    <div class="card-body">
        <div>
            <h5>A PAC informada não possui detalhamento</h5>
        </div>
    </div>
</ng-template>